import { useSession } from '@side/next-auth/react';
import type { Scopes } from './constants';

interface Options {
  roles?: string[];
  scopes?: Scopes[];
}

export function useHasPermission({ roles, scopes }: Options) {
  const session = useSession();
  const userRoles = session?.data?.user?.roles ?? [];

  const hasRequiredRoles =
    !roles?.length || roles.every((r) => userRoles.includes(r));
  const hasRequiredScopes =
    !scopes?.length || Boolean(session?.data?.hasScopes?.(scopes));

  return {
    loading: session.status === 'loading',
    hasPermission: hasRequiredRoles && hasRequiredScopes,
  };
}
